package one.healthium.profile.ui.update_weight

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel
import kotlin.time.Instant

internal class UpdateWeightViewModel(
    private val userInteractor: UserInteractor,
    appPreferences: AppPreferences,
) : BaseViewModel() {
    private val _state = MutableStateFlow(UpdateWeightUiState())

    val uiMessages = UiMessageManager()
    val events = EventProducer<UpdateWeightEvent>()

    init {
        appPreferences.isMetricFlow
            .onEach { isMetric ->
                _state.update { state ->
                    state.copy(
                        isMetric = isMetric,
                    )
                }
            }
            .launch()
    }

    fun state(weight: Float, date: Instant): StateFlow<UpdateWeightUiState> {
        if (_state.value.originalWeight != weight || _state.value.originalWeightDate != date) {
            _state.update { state ->
                state.copy(
                    originalWeight = weight,
                    originalWeightDate = date,
                    currentWeight = weight,
                )
            }
        }
        return _state.asStateFlow()
    }

    fun onWeightChanged(value: Float) {
        _state.update { state ->
            state.copy(currentWeight = value)
        }
    }

    fun onSaveClicked() {
        val weightToEdit = _state.value.originalWeight
        val weightToEditDate = _state.value.originalWeightDate
        val currentWeight = _state.value.currentWeight
        if (weightToEdit == null || weightToEditDate == null || currentWeight == weightToEdit) {
            return
        }

        launch {
            _state.update { state -> state.copy(loading = true) }
            try {
                userInteractor.setWeightForDate(weightToEditDate, currentWeight)
                events.trigger(UpdateWeightEvent.OnWeightUpdated)
            } catch (e: Exception) {
                Logger.e(e) { "Failed to update weight" }
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state -> state.copy(loading = false) }
            }
        }
    }
}